import { useAppTranslation } from '@hooks/useAppTranslation';
import { useSharedStackScreenOptions } from '@hooks/useSharedStackScreenOptions';
import { Stack } from 'expo-router';

export default function ReportCreationLayout(): React.ReactNode {
  const { t } = useAppTranslation();
  const screenOptions = useSharedStackScreenOptions();

  return (
    <Stack screenOptions={screenOptions}>
      <Stack.Screen
        name="index"
        options={{
          headerTitle: t('reportCreation.title'),
        }}
      />
      <Stack.Screen
        name="similar/index"
        options={{
          headerTitle: t('reportCreation.similarReports.title'),
        }}
      />
      <Stack.Screen
        name="similar/[reportId]"
        options={{
          headerTitle: t('reports.detailTitle', 'Report details'),
        }}
      />
      <Stack.Screen
        name="species/index"
        options={{
          headerTitle: t('speciesSearch.title'),
        }}
      />
      <Stack.Screen
        name="species/ai"
        options={{
          headerTitle: t('speciesSearch.ai.title'),
        }}
      />
      <Stack.Screen
        name="species/taxonomy"
        options={{
          headerTitle: t('speciesSearch.taxonomy.title'),
        }}
      />
    </Stack>
  );
}
